// extracted by mini-css-extract-plugin
export var container = "_2i-0";